/**
 * `src/combat` public surface. Owner: Combat — P3 (simulation `sim/`, AI, ghosts, odds, rewards as `ArenaFact`, balance
 * harness; log types frozen at P3-M1 in `types.ts`) and P4 (`director/`, `screens/`, `audio/`).
 * May import: shared, content/combat, content/fx, `import type` from creature; ui/engine only under `screens/` and
 * `director/`; the animation runtime only through `ctx.services.creatures.anim` (architecture §1.1).
 */
import type { FeatureModule } from '../shared';
import { combatSlice } from './save';
import { combatScreens } from './screens';
import { runDuel, type DuelSpec } from './sim';

export const combat: FeatureModule = {
  key: 'combat',
  slices: [combatSlice],
  screens: combatScreens,
  onBoot(ctx) {
    ctx.services.combat = {
      buildSpec(creatureId, opts) {
        return { seed: ctx.store.state.seed + ':auto:' + creatureId, opponent: 'knight', level: ctx.services.economy.level(creatureId), ...opts };
      },
      runAuto(spec) {
        const state = runDuel(spec as DuelSpec);
        return { winner: state.winner!, reason: state.hp === 0 || state.foeHp === 0 ? 'ko' : 'judges', events: state.beats.length, hpLeft: [state.hp, state.foeHp] };
      },
    };
  },
  debugApi: () => ({ combat: {} }),
};

export { combatSlice, type CombatSave } from './save';
